// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file trade/v1/purchase_order_line_item.proto (package trade.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Base, ID, Money } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file trade/v1/purchase_order_line_item.proto.
 */
export const file_trade_v1_purchase_order_line_item: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_protobuf_wrappers, file_types]);

/**
 * PurchaseOrderLineItem message definition
 *
 * @generated from message trade.v1.PurchaseOrderLineItem
 */
export type PurchaseOrderLineItem = Message<"trade.v1.PurchaseOrderLineItem"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID purchase_order_id = 2;
   */
  purchaseOrderId?: ID;

  /**
   * @generated from field: types.ID facility_id = 3;
   */
  facilityId?: ID;

  /**
   * @generated from field: types.ID item_id = 4;
   */
  itemId?: ID;

  /**
   * @generated from field: string unit = 5;
   */
  unit: string;

  /**
   * @generated from field: string quantity = 6;
   */
  quantity: string;

  /**
   * @generated from field: types.Money unit_price = 7;
   */
  unitPrice?: Money;

  /**
   * @generated from field: types.Money total_price = 8;
   */
  totalPrice?: Money;

  /**
   * @generated from field: string allocated_quantity = 9;
   */
  allocatedQuantity: string;

  /**
   * @generated from field: string received_quantity = 10;
   */
  receivedQuantity: string;

  /**
   * @generated from field: types.Base base = 11;
   */
  base?: Base;
};

/**
 * Describes the message trade.v1.PurchaseOrderLineItem.
 * Use `create(PurchaseOrderLineItemSchema)` to create a new message.
 */
export const PurchaseOrderLineItemSchema: GenMessage<PurchaseOrderLineItem> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order_line_item, 0);

/**
 * Request/Response messages for PurchaseOrderLineItem queries
 *
 * @generated from message trade.v1.GetPurchaseOrderLineItemRequest
 */
export type GetPurchaseOrderLineItemRequest = Message<"trade.v1.GetPurchaseOrderLineItemRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message trade.v1.GetPurchaseOrderLineItemRequest.
 * Use `create(GetPurchaseOrderLineItemRequestSchema)` to create a new message.
 */
export const GetPurchaseOrderLineItemRequestSchema: GenMessage<GetPurchaseOrderLineItemRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order_line_item, 1);

/**
 * @generated from message trade.v1.GetPurchaseOrderLineItemResponse
 */
export type GetPurchaseOrderLineItemResponse = Message<"trade.v1.GetPurchaseOrderLineItemResponse"> & {
  /**
   * @generated from field: trade.v1.PurchaseOrderLineItem purchase_order_line_item = 1;
   */
  purchaseOrderLineItem?: PurchaseOrderLineItem;
};

/**
 * Describes the message trade.v1.GetPurchaseOrderLineItemResponse.
 * Use `create(GetPurchaseOrderLineItemResponseSchema)` to create a new message.
 */
export const GetPurchaseOrderLineItemResponseSchema: GenMessage<GetPurchaseOrderLineItemResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order_line_item, 2);

/**
 * @generated from message trade.v1.ListPurchaseOrderLineItemsRequest
 */
export type ListPurchaseOrderLineItemsRequest = Message<"trade.v1.ListPurchaseOrderLineItemsRequest"> & {
  /**
   * @generated from field: trade.v1.ListPurchaseOrderLineItemsFilter filter = 1;
   */
  filter?: ListPurchaseOrderLineItemsFilter;

  /**
   * @generated from field: repeated trade.v1.PurchaseOrderLineItemSortOption sorting = 2;
   */
  sorting: PurchaseOrderLineItemSortOption[];

  /**
   * @generated from field: int32 offset = 3;
   */
  offset: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message trade.v1.ListPurchaseOrderLineItemsRequest.
 * Use `create(ListPurchaseOrderLineItemsRequestSchema)` to create a new message.
 */
export const ListPurchaseOrderLineItemsRequestSchema: GenMessage<ListPurchaseOrderLineItemsRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order_line_item, 3);

/**
 * @generated from message trade.v1.ListPurchaseOrderLineItemsFilter
 */
export type ListPurchaseOrderLineItemsFilter = Message<"trade.v1.ListPurchaseOrderLineItemsFilter"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: google.protobuf.StringValue purchase_order_id = 2;
   */
  purchaseOrderId?: string;

  /**
   * @generated from field: google.protobuf.StringValue facility_id = 3;
   */
  facilityId?: string;

  /**
   * @generated from field: google.protobuf.StringValue item_id = 4;
   */
  itemId?: string;

  /**
   * @generated from field: google.protobuf.StringValue search_term = 11;
   */
  searchTerm?: string;

  /**
   * @generated from field: types.ID organization_id = 12;
   */
  organizationId?: ID;
};

/**
 * Describes the message trade.v1.ListPurchaseOrderLineItemsFilter.
 * Use `create(ListPurchaseOrderLineItemsFilterSchema)` to create a new message.
 */
export const ListPurchaseOrderLineItemsFilterSchema: GenMessage<ListPurchaseOrderLineItemsFilter> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order_line_item, 4);

/**
 * @generated from message trade.v1.ListPurchaseOrderLineItemsResponse
 */
export type ListPurchaseOrderLineItemsResponse = Message<"trade.v1.ListPurchaseOrderLineItemsResponse"> & {
  /**
   * @generated from field: repeated trade.v1.PurchaseOrderLineItem purchase_order_line_items = 1;
   */
  purchaseOrderLineItems: PurchaseOrderLineItem[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message trade.v1.ListPurchaseOrderLineItemsResponse.
 * Use `create(ListPurchaseOrderLineItemsResponseSchema)` to create a new message.
 */
export const ListPurchaseOrderLineItemsResponseSchema: GenMessage<ListPurchaseOrderLineItemsResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order_line_item, 5);

/**
 * Input messages
 *
 * @generated from message trade.v1.PurchaseOrderLineItemInput
 */
export type PurchaseOrderLineItemInput = Message<"trade.v1.PurchaseOrderLineItemInput"> & {
  /**
   * @generated from field: types.ID purchase_order_id = 1;
   */
  purchaseOrderId?: ID;

  /**
   * @generated from field: types.ID item_id = 2;
   */
  itemId?: ID;

  /**
   * @generated from field: string unit = 3;
   */
  unit: string;

  /**
   * @generated from field: string quantity = 4;
   */
  quantity: string;

  /**
   * @generated from field: types.Money unit_price = 5;
   */
  unitPrice?: Money;

  /**
   * @generated from field: types.Money total_price = 6;
   */
  totalPrice?: Money;
};

/**
 * Describes the message trade.v1.PurchaseOrderLineItemInput.
 * Use `create(PurchaseOrderLineItemInputSchema)` to create a new message.
 */
export const PurchaseOrderLineItemInputSchema: GenMessage<PurchaseOrderLineItemInput> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order_line_item, 6);

/**
 * @generated from message trade.v1.PurchaseOrderLineItemUpdateInput
 */
export type PurchaseOrderLineItemUpdateInput = Message<"trade.v1.PurchaseOrderLineItemUpdateInput"> & {
  /**
   * @generated from field: types.ID purchase_order_id = 1;
   */
  purchaseOrderId?: ID;

  /**
   * @generated from field: types.ID item_id = 2;
   */
  itemId?: ID;

  /**
   * @generated from field: google.protobuf.StringValue unit = 3;
   */
  unit?: string;

  /**
   * @generated from field: google.protobuf.StringValue quantity = 4;
   */
  quantity?: string;

  /**
   * @generated from field: google.protobuf.StringValue unit_price = 5;
   */
  unitPrice?: string;

  /**
   * @generated from field: google.protobuf.StringValue total_price = 6;
   */
  totalPrice?: string;
};

/**
 * Describes the message trade.v1.PurchaseOrderLineItemUpdateInput.
 * Use `create(PurchaseOrderLineItemUpdateInputSchema)` to create a new message.
 */
export const PurchaseOrderLineItemUpdateInputSchema: GenMessage<PurchaseOrderLineItemUpdateInput> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order_line_item, 7);

/**
 * @generated from enum trade.v1.PurchaseOrderLineItemSortOption
 */
export enum PurchaseOrderLineItemSortOption {
  /**
   * @generated from enum value: PURCHASE_ORDER_LINE_ITEM_SORT_OPTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PURCHASE_ORDER_LINE_ITEM_SORT_OPTION_CREATED_AT_ASC = 1;
   */
  CREATED_AT_ASC = 1,

  /**
   * @generated from enum value: PURCHASE_ORDER_LINE_ITEM_SORT_OPTION_CREATED_AT_DESC = 2;
   */
  CREATED_AT_DESC = 2,

  /**
   * @generated from enum value: PURCHASE_ORDER_LINE_ITEM_SORT_OPTION_UPDATED_AT_ASC = 3;
   */
  UPDATED_AT_ASC = 3,

  /**
   * @generated from enum value: PURCHASE_ORDER_LINE_ITEM_SORT_OPTION_UPDATED_AT_DESC = 4;
   */
  UPDATED_AT_DESC = 4,
}

/**
 * Describes the enum trade.v1.PurchaseOrderLineItemSortOption.
 */
export const PurchaseOrderLineItemSortOptionSchema: GenEnum<PurchaseOrderLineItemSortOption> = /*@__PURE__*/
  enumDesc(file_trade_v1_purchase_order_line_item, 0);

/**
 * Services
 *
 * @generated from service trade.v1.PurchaseOrderLineItemQueriesService
 */
export const PurchaseOrderLineItemQueriesService: GenService<{
}> = /*@__PURE__*/
  serviceDesc(file_trade_v1_purchase_order_line_item, 0);

/**
 * @generated from service trade.v1.PurchaseOrderLineItemCommandsService
 */
export const PurchaseOrderLineItemCommandsService: GenService<{
}> = /*@__PURE__*/
  serviceDesc(file_trade_v1_purchase_order_line_item, 1);

